import {
    subMonths,
    addMonths,
    format,
    startOfWeek,
    addDays,
    startOfMonth,
    endOfMonth,
    endOfWeek,
    isSameMonth,
    subDays,
    parseISO,
    isBefore,
} from "date-fns";

import React, { useState, useEffect } from "react";
import "../assets/styles/calendar.css";
import axios from "axios";

import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const apiUrl = `${process.env.REACT_APP_SERVER_URL}`;



export const CalendarList = () => {
    let daysEvent;

    const [viewedEvents, setViewedEvents] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(new Date());
    let eventsTable ={}


    useEffect(() => {
        async function fetchData() {
            const url = `${apiUrl}/orders/getOrdersByDate`;
            const monthStart = startOfMonth(currentMonth);
            const monthEnd = endOfMonth(monthStart);
            const startDate = startOfWeek(monthStart);
            const endDate = endOfWeek(monthEnd);
            let params = {
                start_of_month: format(startDate, "yyyy-MM-dd"),
                end_of_month: format(endDate, "yyyy-MM-dd"),
            };
            
            const token = localStorage.getItem("token")
            const response = await axios.get(url, {params, headers: {"Authorization" : `Bearer ${token}`} });
            let newItems = [];
            let daysEvents = [];
            let newEvents = response.data.responseData.map((order) => {
                order["color"] = "#" + (((1 << 24) * Math.random()) | 0).toString(16);
                let startFormated = subDays(parseISO(order.rented_from), 1);
                const endFormated = parseISO(order.rented_to);
                while (isBefore(startFormated, endFormated)) {
                    daysEvents.push(order);
                    startFormated = addDays(startFormated, 1);
                }
                daysEvents.push(order);
                const subset = {
                    id: order.item_id,
                    name: order.name,
                };
                newItems.push(subset);

                return order;
            });
            setAllEvents(newEvents);
            setViewedEvents(newEvents);

        }
        fetchData();
    }, [currentMonth]);

    const handleEventsTable = () =>{
       let tmp
       for(let i =0 ; i<allEvents.length;i++){
                tmp = eventsTable
                if(tmp[allEvents[i].name]){
                    tmp[allEvents[i].name].push(allEvents[i])
                }
                else{
                    tmp[allEvents[i].name]=[allEvents[i]]
                }
                
       }
    }
    const nextMonth = () => {
        setCurrentMonth(addMonths(currentMonth, 1));
    };
    const prevMonth = () => {
        setCurrentMonth(subMonths(currentMonth, 1));
    };

    const renderHeader = () => {
        const dateFormat = "MMMM yyyy";
        return (
            <div className="header row flex-middle">
                <div className="col col-start">
                    <div className="icon" onClick={prevMonth}>
                        chevron_left
                    </div>
                </div>
                <div className="col col-center">
                    <span>{format(currentMonth, dateFormat)}</span>
                </div>
                <div className="col col-end" onClick={nextMonth}>
                    <div className="icon">chevron_right</div>
                </div>
            </div>
        );
    };

    const renderDays = () => {
        const dateFormat = "E";
        const days = [];
        let startDate = startOfWeek(currentMonth);
        for (let i = 0; i < 7; i++) {
            let day = format(addDays(startDate, i), dateFormat);
            days.push(
                <div className="col col-center" key={i}>
                    {day}
                </div>
            );
        }
        return <div className="days row">{days}</div>;
    };

    const renderCells = () => {
        const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(monthStart);
        const startDate = startOfWeek(monthStart);
        const endDate = endOfWeek(monthEnd);

        const dateFormat = "d";
        const rows = [];

        let days = [];
        let day = startDate;
        let formattedDate = "";

        while (day <= endDate) {
            for (let i = 0; i < 7; i++) {
                formattedDate = format(day, dateFormat);
                days.push(
                    <div className={`col cell `} key={day}>
                        <span className={`number ${!isSameMonth(day, monthStart) ? "disabled" : ""}`}>{formattedDate}</span>
                        <span className="bg">{formattedDate}</span>

                        {/* {renderEven} */}
                        {isBooked(day) &&
                            daysEvent.map((order) => (
                                <>
                                    <div className={`event-item ${order.id}`} key={order.id}>
                                        <span className="indicator" style={{ background: order.color }}></span>
                                        <small>{order.name}</small>
                                    </div>
                                </>
                            ))}
                    </div>
                );

                day = addDays(day, 1);
            }
            rows.push(
                <div className="row" key={day}>
                    {days}
                </div>
            );
            days = [];
        }

        return <div className="body">{rows}</div>;
    };

    const isBooked = (date) => {
        let sameDays = viewedEvents.filter((order) => addDays(date, 1) >= parseISO(order.rented_from) && date <= parseISO(order.rented_to));
        daysEvent = sameDays;
        return daysEvent.length > 0;
    };

    const handleInput = (e, value) => {
        if (value) {
            setViewedEvents([...eventsTable[value]]);
        } else {
            setViewedEvents(allEvents);
        }
    };

    return (
        <>
            <div >
                {handleEventsTable()}
            <Autocomplete
                disablePortal
                id="free-solo-demo"
                options={Object.keys(eventsTable)}
                onChange={(e, value) => handleInput(e, value)}
                getOptionLabel={(option) => option}
                style={{ width: "20%" }}
                renderInput={(params) => <TextField {...params} label="Item" margin="normal" variant="outlined" />}
            />
            </div>
            <div className="calendar">
                {renderHeader()}
                {renderDays()}
                {renderCells()}
            </div>
        </>
    );
};
